import React, { useState } from "react";
import ReactCardFlip from "react-card-flip";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Card from "@mui/material/Card";

function Inclusion() {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setIsFlipped(!isFlipped);
  };

  return (
    <Grid
      item
      alignItems={"center"}
      xs={12}
      md={4}
      marginBottom={{ xs: "7%", sm: "0%" }}
      marginLeft={{ xs: "0%", sm: "0%" }}
      position={"relative"}
    >
      <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical">
        <Box
          backgroundColor={"#4B56D2"}
          component={Card}
          sx={{
            textDecoration: "none",
            textAlign: "center",
            "&:hover": {
              backgroundColor: "#D7A036",
            },
          }}
          position={"relative"}
          height={{ xs: "30vh", sm: "360px" }}
        >
          <Typography
            variant={"h5"}
            fontWeight={800}
            color={"#fff"}
            sx={{
              "&:hover": {
                color: "#ddd",
              },
            }}
            marginTop={"5%"}
            position={"absolute"}
            top={{ xs: "25%", sm: "15%" }}
            padding={{ xs: "2%", sm: "12%" }}
            width={"100%"}
            textAlign={"center"}
          >
            Award for Inclusion & Diversity
            <Typography
              component={"span"}
              color="#fff"
              fontWeight={700}
              variant={"body2"}
            >
              {" "}
              - [Research]
            </Typography>
          </Typography>
          <AutorenewIcon
            onClick={handleClick}
            sx={{
              bottom: "4%",
              right: "5%",
              cursor: "pointer",
              textAlign: "right",
              position: "absolute",
              color: "#fff",
            }}
          />
        </Box>
        <Box>
          <Typography
            variant={"body1"}
            color={"#fff"}
            padding={{ xs: "5%", sm: "7%" }}
          >
            This award recognizes the work of a person/organization in
            entrenching equality through the promotion of inclusion and
            diversity of marginalized groups.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#fff"}
            padding={{ xs: "0% 2% 0% 5%", sm: "5% 2% 1% 5%" }}
            fontWeight={800}
          >
            2023 Winner
          </Typography>
          <Typography
            variant={"body1"}
            color={"#fff"}
            padding={{ xs: "0% 2% 0% 5%", sm: "0% 2% 0% 5%" }}
            fontWeight={500}
          >
            Inclusive Friends
          </Typography>
          <AutorenewIcon
            onClick={handleClick}
            sx={{
              bottom: "0%",
              right: "4%",
              cursor: "pointer",
              textAlign: "right",
              position: "absolute",
            }}
          />
        </Box>
      </ReactCardFlip>
    </Grid>
  );
}

export default Inclusion;
